import React from 'react';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import OverlayExample from './Overlay/OverlayCard';
import projectData from './projectsData.json';
import '../ProjectsComponent/Projects.css';

function ProjectGrid() {
  const itemsPerPage = 3;
  const totalPages = Math.ceil(projectData.length / itemsPerPage);
  const [activePage, setActivePage] = React.useState(1);
  const startIndex = (activePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const renderProjectCards = () => {
    return projectData.slice(startIndex, endIndex).map((project) => (
      <div key={project.id} className="col-xl-4 col-lg-4 col-md-6 layCard">
        <Card className="giveMargin custom-card h-100 d-flex flex-column">
          <div style={{ flex: '1' }}>
            <Card.Img
              variant="top"
              src={require(`./${project.image}`)}
              className="custom-card-image"
              style={{ objectFit: 'cover', width: '100%', height: '50%' }}
            />
            <Card.Body style={{ minHeight: '8rem' }}>
              <Card.Title>{project.title}</Card.Title>
              <Card.Text style={{ maxHeight: '8rem', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {project.abstract}
              </Card.Text>
            </Card.Body>
          </div>
          <div style={{ borderTop: '1px solid rgba(0,0,0,0.125)', padding: '1rem' }}>
            <OverlayExample
              modalTitle={project.title}
              modalText={project.description}
              saveButtonText="Back To WebSite"
              image={require(`./${project.image}`)}
            />
          </div>
        </Card>
      </div>
    ));
  };

  const renderPaginationItems = () => {
    const items = [];
    for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
      items.push(
        <Pagination.Item
          key={pageNumber}
          active={pageNumber === activePage}
          onClick={() => handlePageChange(pageNumber)}
        >
          {pageNumber}
        </Pagination.Item>
      );
    }
    return items;
  };

  return (
    <div className="row lay justify-content-center col-11">
      <b id="projects" className="TitleEmphasis">
        <box-icon name="briefcase" animation="flashing" size="md"></box-icon> Projects
      </b>
      <p style={{ color: 'gray', fontWeight: 'bold' }}>———————— Here are some of my projects ————————</p>

      <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', padding: '1rem', borderRadius: '1rem' }}>
        <div className="d-flex justify-content-center">
          <div className="testMargin d-flex flex-wrap justify-content-center col-10">
            {renderProjectCards()}
          </div>
        </div>
        <div className="pagination-container justify-content-center">
          <Pagination className="justify-content-center">{renderPaginationItems()}</Pagination>
        </div>
      </div>
    </div>
  );
}

export default ProjectGrid;
